import { render, staticRenderFns } from "./additionService.vue?vue&type=template&id=58c6ff6f&scoped=true"
import script from "./additionService.vue?vue&type=script&lang=js"
export * from "./additionService.vue?vue&type=script&lang=js"
import style0 from "./additionService.vue?vue&type=style&index=0&id=58c6ff6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c6ff6f",
  null
  
)

export default component.exports